import DataFeedDispatcher from '../dispatcher/DataFeedDispatcher';
import DataFeedConstants from '../constants/DataFeedConstants';
import EventEmitterObj from 'events';

var EventEmitter = EventEmitterObj.EventEmitter;
import merge from 'merge';
import assign from 'object-assign';
import DataFeedActions from '../actions/DataFeedActions';

var _organisation = {};
var _isLoading = true;
var _organisationTypeToView = 0;
let _contractors = [];
let _viewDataFromContractorID = -1;
let _unapprovedPile = [];
let _processUnapproveList = {};
let _noMoreToProcess = false;
let _pileTypeToLoad = "all";
let _processedInSession = 0;

function setOrganisation(data) {

    _organisation = data;
}

function setLoading(isLoading) {

    _isLoading = isLoading;
}

function setOrganisationTypeToView(organisationType) {

    _organisationTypeToView = organisationType;

    setOneRecord();
}

function loadContractors() {

    const request = new XMLHttpRequest();

    request.open("GET", 'api/proxy/api/v1/data-feed/contractors');
    request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

    request.onreadystatechange = function () {

        if (request.readyState === 4) {

            if (request.status === 200) {

                DataFeedActions.storeContractors(JSON.parse(request.responseText));
            }
        }
    };

    request.send();
}

function storeContractors(contractors) {

    _contractors = contractors;
}

function editOrganisation(data) {
    var request = new XMLHttpRequest();

    request.open('PUT', 'api/proxy/api/v1/data-feed/record/' + data.organisationId);
    request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

    request.onreadystatechange = function () {
        if (request.readyState === 4) {
            DataFeedStore.setOneRecord();
        }
    };

    request.send(JSON.stringify(data));
}

function setContractorToViewDataFor(contractorID) {
    _viewDataFromContractorID = contractorID;

    setOneRecord();
}

function loadNonApprovedForPile() {
    _processUnapproveList = {}

    const pileURLToFetchDataFrom = {

        all: "unapproved-pile",
        telco: "smells-like-telco",
        machine: "unapproved-pile-machine",
        neustar: "neustar-telco"
    }

    loadPile(pileURLToFetchDataFrom[_pileTypeToLoad]);
}

function loadPile(fetchURL) {

    const request = new XMLHttpRequest();

    const url = "/api/proxy/api/v1/data-feed/" + fetchURL;

    request.open("GET", url);
    request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

    request.onreadystatechange = function () {

        if (request.readyState === 4) {
            switch (request.status) {
                case 200 :
                    DataFeedActions.storeUnapprovedPile(JSON.parse(request.responseText));

                    break;
                default :
                    DataFeedActions.setNoMoreToProcess();

                    break;
            }
        }
    };

    request.send();
}

function setNoMoreToProcess() {
    _noMoreToProcess = true;
}

function setOneRecord() {
    if (_viewDataFromContractorID > -1) {
        const request = new XMLHttpRequest();

        let url = 'api/proxy/api/v1/data-feed/by-contractor';

        request.open('POST', url);
        request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');

        request.onreadystatechange = function () {
            if (request.readyState === 4 && request.status === 200) {
                DataFeedStore.setInitialOrganisation(JSON.parse(request.responseText));

                DataFeedActions.setLoading(false);
            }
        };

        request.send(JSON.stringify({
                contractorID: _viewDataFromContractorID,
                organisationType: _organisationTypeToView
            })
        );
    } else {
        const request = new XMLHttpRequest();
        let url = 'api/proxy/api/v1/data-feed/new';

        if (_organisationTypeToView > 0) {
            url = `api/proxy/api/v1/data-feed/by-type/${_organisationTypeToView}`;
        }

        request.open('GET', url);

        request.onreadystatechange = function () {
            if (request.readyState === 4 && request.status === 200) {
                DataFeedStore.setInitialOrganisation(JSON.parse(request.responseText));

                DataFeedActions.setLoading(false);
            }
        };

        request.send();
    }
}

function clone(obj) {

    if (null == obj || "object" != typeof obj) return obj;
    var copy = obj.constructor();
    for (var attr in obj) {
        if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
    }
    return copy;
}

function removeFromPile(orgID) {

    if (_processUnapproveList[orgID] === 1) {

        _processUnapproveList[orgID] = 0;

    } else {

        _processUnapproveList[orgID] = 1;
    }
}

function setPileCheckToLoadType(type) {

    _pileTypeToLoad = type;

    loadNonApprovedForPile();
}

function storeUnapprovedPile(unapprovedPile) {

    _unapprovedPile = unapprovedPile;

    let processUnapproveList = {};

    unapprovedPile.forEach(function (organisation, i) {

        processUnapproveList[organisation.id] = 1;
    });

    _processUnapproveList = processUnapproveList;
}

function processUnapproved() {

    _unapprovedPile = [];

    _processedInSession += 20;

    const request = new XMLHttpRequest();

    const url = "/api/proxy/api/v1/data-feed/unapproved-pile";

    request.open("POST", url);
    request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

    request.onreadystatechange = function () {

        if (request.readyState === 4) {

            switch (request.status) {

                case 200 :

                    DataFeedActions.loadNonApprovedForPile();

                    break;
            }
        }
    };

    request.send(JSON.stringify({process: _processUnapproveList}));
}

var DataFeedStore = merge(EventEmitter.prototype, {


    isLoading: function () {

        return _isLoading;
    },

    getNoMoreToProcess: function () {

        return _noMoreToProcess;
    },

    getOneRecord: function () {

        return _organisation;
    },

    getFilterByOrganisationTypeID: function () {

        return _organisationTypeToView;
    },

    getProcessedInSession: function () {

        return _processedInSession;
    },

    setInitialOrganisation: function (data) {
        _organisation = data;

        DataFeedStore.emitChange();
    },

    getContractors: function () {

        return _contractors;
    },

    getPileSelection: function () {

        return _processUnapproveList;
    },

    getUnapprovedPile: function () {

        return clone(_unapprovedPile);
    },

    setOneRecord: function () {
        setOneRecord();
    },

    getContractorToViewDataFor: function () {

        return _viewDataFromContractorID;
    },

    getOrganisation: function () {

        return _organisation;
    },

    emitChange: function () {

        this.emit('change');
    },

    addChangeListener: function (callback) {

        this.on('change', callback);
    },

    removeChangeListener: function (callback) {

        this.removeListener('change', callback);
    }

});

DataFeedDispatcher.register(function (payload) {
    let returnRes = true;

    switch (payload.actionType) {
        case DataFeedConstants.EDIT_ORGANISATION :
            editOrganisation(payload.data.storedValue);

            break;
        case DataFeedConstants.STORE_UNAPPROVED_PILE :

            storeUnapprovedPile(payload.data);

            break;

        case DataFeedConstants.GET_ORGANISATION :

            getOrganisation(payload);

            break;

        case DataFeedConstants.LOAD_ORGANISATIONS :


            break;

        case DataFeedConstants.SET_ORGANISATION :

            setOrganisation(payload);

            break;

        case DataFeedConstants.SET_PILE_CHECK_TO_LOAD_TYPE :

            setPileCheckToLoadType(payload.data);

            break;

        case DataFeedConstants.PROCESS_UNAPPROVED :

            processUnapproved();

            break;

        case DataFeedConstants.STORE_CONTRACTORS :

            storeContractors(payload.data);

            break;

        case DataFeedConstants.SET_NO_MORE_TO_PROCESS :

            setNoMoreToProcess();

            break;

        case DataFeedConstants.SET_LOADING :

            setLoading(payload.data);

            break;

        case DataFeedConstants.LOAD_CONTRACTORS :

            loadContractors();

            break;

        case DataFeedConstants.SET_ORGANISATION_TYPE_TO_VIEW :

            setOrganisationTypeToView(payload.data);

            break;

        case DataFeedConstants.SET_CONTRACTOR_TO_VIEW_DATA_FOR :

            setContractorToViewDataFor(payload.data);

            break;

        case DataFeedConstants.LOAD_NON_APPROVED_FOR_PILE :

            loadNonApprovedForPile();

            break;

        case DataFeedConstants.REMOVE_FROM_PILE :

            removeFromPile(payload.data);

            break;


        default:

            return true;

            break;
    }

    DataFeedStore.emitChange();

    return returnRes;

});

export default DataFeedStore;



// WEBPACK FOOTER //
// ./resources/assets/js/data-feed/stores/DataFeedStore.js